<template>
  <div
    class="col-lg-12 ctr_trm"
    @copy.prevent
    @cut.prevent
    @selectstart.prevent
  >
    <h2 class="head_txt">
      Kebijakan Privasi, Perlindungan dan Penggunaan Data Pribadi
    </h2>
    <p class="p1 subtitle">PT Digital Kripto Indonesia</p>
    <p class="p1">
      Kebijakan Privasi ini mengatur cara Pegasus Exchange meminta, memperoleh,
      mengumpulkan, mengolah, menyimpan, memelihara, menggunakan, mengungkapkan
      dan meneruskan Data Pribadi Konsumen yang dikumpulkan Konsumen dari
      website
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >
      (“Pegasus Exchange”). Pegasus Exchange berkomitmen untuk bertanggung jawab
      berdasarkan peraturan perundang-undangan tentang privasi yang berlaku di
      Indonesia, serta berkomitmen penuh untuk mengupayakan perlindungan
      kerahasiaan Data Pribadi Konsumen sesuai dengan ketentuan dalam Kebijakan
      Privasi ini, menghormati hak dan masalah privasi semua Konsumen yang
      terdaftar dalam Platform kami dan tidak menggunakan Data Pribadi tersebut
      untuk tujuan apa pun selain untuk pemberian fasilitas transaksi kripto dan
      pelaksanaan kegiatan usaha Pegasus Exchange, operasional maupun pemberian
      jasa dan layanan Pegasus Exchange dengan ketentuan Kebijakan Privasi ini.
      Kebijakan privasi ini berlaku untuk Platform dan semua produk dan layanan
      yang ditawarkan Pegasus Exchange.
    </p>
    <p class="p1">
      Penting bagi Konsumen dalam mengerti dan memahami Kebijakan Privasi ini
      bersama dengan informasi lainya yang berlaku yang akan digunakan dalam
      menjadi dasar pengelolaan data pribadi Konsumen. Kebijakan Privasi ini
      dirancang untuk membantu Konsumen untuk memahami bagaimana Pegasus
      Exchange mengumpulkan, menggunakan, memelihara dan mengungkapkan data
      pribadi yang telah Konsumen percayakan kepada Pegasus Exchange, baik di
      masa sekarang maupun di masa mendatang, serta untuk membantu Konsumen
      membuat keputusan yang tepat sebelum memberikan data pribadi Konsumen
      kepada Pegasus Exchange. Dengan tetap mengakses dan selalu menggunakan
      Layanan Pegasus Exchange, maka dengan ini Konsumen dianggap menyetujui
      segala Kebijakan Privasi yang tertera pada platform Pegasus Exchange
      berikut perubahan-perubahannya
    </p>
    <h2 class="text_h">Definisi</h2>
    <p class="p1">
      1.“Data Pribadi” adalah data, informasi dan/atau keterangan mengenai atau
      terkait Pengguna yang diperoleh dan/diakses oleh Pegasus Exchange dari
      Pengguna dan/atau disingkapkan. Dicantumkan dan/atau diberikan oleh
      Pengguna kepada Pegasus Exchange dalam atau terkait penggunaan layanan
      oleh Pengguna melalui Platform dengan cakupan Data Pribadi yang diatur
      dalam peraturan terkait Perlindungan Data Pribadi di Indonesia.
    </p>
    <p class="p1">
      2.“Pegasus Exchange” adalah PT Digital Kripto Indonesia, suatu perseroan
      terbatas yang didirikan dan dikelola berdasarkan hukum Republik Indonesia,
      beralamat di AXA Tower, Kuningan city, Axa Tower, Jl. Prof. DR. Satrio,
      RT.14/RW.4, Kuningan, Karet Kuningan, Kecamatan Setiabudi, Kota Jakarta
      Selatan, Daerah Khusus Ibukota Jakarta 12940
    </p>
    <p class="p1">
      3.“Platform Pegasus Exchange” adalah (a) portal web dan/atau versi mobile
      dari portal web yang dibuat, dimiliki dan dioperasikan oleh Pegasus
      Exchange yang saat ini terletak di dan dapat diakses pada URL berikut:
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >
      berikut perubahan URL tersebut dari waktu ke waktu; dan/atau (b) aplikasi
      mobile dari
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >
      yang dibuat, dimiliki dan dioperasikan oleh Pegasus Exchange, termasuk iOS
      dan android (berikut perubahannya dari waktu ke waktu).
    </p>
    <p class="p1">
      4.“Pengguna atau Konsumen atau Anda” adalah pihak yang memanfaatkan
      Platform dan Layanan yang disediakan oleh Pegasus Exchange.
    </p>
    <h2 class="text_h">Keberlakuan dan Persetujuan atas Layanan</h2>
    <p class="p1">
      Anda selaku Pengguna dianggap telah setuju secara hukum untuk terikat dan
      tunduk kepada Kebijakan Privasi ini, ketika:
    </p>
    <p class="p1">
      1.Pengguna telah mencantumkan On-Time Password (OTP). yang dikirimkan oleh
      Pegasus Exchange ke nomor telepon milik Pengguna yang dicantumkan dalam
      Platform sebagai Langkah awal untuk melakukan transaksi, dan/atau;
    </p>
    <p class="p1">
      2.Pengguna memilih opsi “Saya telah membaca , memahami dan menyetujui
      Kebijakan Perlindungan dan Penggunaan Data Pribadi ini” sebagai wujud
      persetujuan yang mengikat Pengguna secara hukum atas ketentuan ini yang
      ditampilkan pada Platform sebelum Pengguna melakukan transaksi.
    </p>
    <h2 class="text_h">Pengumpulan informasi</h2>
    <p class="p1">
      Dari waktu ke waktu, Pegasus Exchange akan mengumpulkan informasi dan data
      tentang Konsumen, termasuk informasi dan data yang dapat kami identifikasi
      dari Konsumen dengan berbagai cara, mengumpulkan menjadi satu, namun tidak
      membatasi, saat Konsumen mengunjungi situs kami, mendaftar di situs, dan
      menghubungkan dengan aktivitas lain yang serupa, yang kami sediakan di
      Situs kami.
    </p>
    <p class="p1">
      1.Data Pribadi adalah setiap data tentang kehidupan seseorang baik yang
      teridentifikasi dan / atau dapat diidentifikasi secara tersendiri atau
      dikombinasi dengan informasi lainnya baik secara langsung maupun tidak
      langsung melalui sistem elektronik dan / atau non elektronik. Data pribadi
      disimpan, dirawat, dan dijaga kebenaran serta dilindungi kerahasiaannya.
    </p>
    <p class="p1">
      2.Pegasus Exchange dapat mengumpulkan Data Pribadi/Informasi Pribadi
      Konsumen, yang termasuk namun tidak terbatas pada nama, tanggal lahir,
      KTP, paspor atau nomor atau keterangan identifikasi lain, alamat, alamat
      email, nomor telepon, rincian kontak, informasi keuangan dan, deskripsi
      dan foto pribadi, pola dan perilaku transaksi, belakang pendidikan dan
      data kependudukan
    </p>
    <p class="p1">
      3.Setiap informasi dan data tentang Konsumen yang kami terima jika Anda
      menggunakan website lain apapun yang dioperasikan oleh kami, afiliasi dan
      anak perusahaan kami atau layanan lain yang disediakan oleh kami, afiliasi
      dan anak perusahaan kami. Dalam hal tersebut, kami akan memberitahu Anda
      dan mendapatkan persetujuan Anda untuk pengumpulan informasi atau data
      tentang Anda dengan Kebijakan Privasi yang terkait yang terkandung dalam
      website lain yang dioperasikan oleh kami.
    </p>
    <p class="p1">
      4.Konsumen setuju untuk tidak menyerahkan setiap informasi yang tidak
      akurat atau menyesatkan, dan Konsumen setuju untuk memberitahukan
      ketidakakuratan atau perubahan dari informasi tersebut. Pegasus Exchange
      memiliki hak atas kebijaksanaan untuk mensyaratkan dokumentasi yang lebih
      lanjut untuk melakukan verifikasi atas informasi yang diserahkan oleh
      Pegasus Exchange.
    </p>
    <h2 class="text_h">Penggunaan Data Pribadi Konsumen</h2>
    <p class="p1">
      Apabila dianggap perlu dan pantas oleh Pegasus Exchange dan sesuai dengan
      hukum, aturan, dan peraturan yang berlaku, maka Data Pribadi Konsumen
      dapat digunakan dan diungkapkan oleh Pegasus Exchange tujuan berikut ini:
    </p>
    <p class="p1">
      1.Konsumen memberikan otorisasi kepada Pegasus Exchange untuk mengumpulkan
      dan menggunakan Data Pribadi Pengguna;
    </p>
    <p class="p1">
      2.Dipersyaratkan atau diperoleh Pegasus Exchange dari Konsumen dan
      diserahkan, disingkapkan, diunduh atau diajukan Konsumen melalui Platform
      Pegasus Exchange atau sumber daya lainnya, termasuk ketika Anda mendaftar
      pada Platform Pegasus Exchange sebagai Pengguna;
    </p>
    <p class="p1">
      3.Ketika Konsumen menggunakan suatu fitur atau fungsi yang tersedia dalam
      platform Pegasus Exchange;
    </p>
    <p class="p1">
      4.Ketika Konsumen mendaftar untuk suatu layanan dari platform Pegasus
      Exchange atau membeli suatu produk aset kripto yang tersedia di platform
      Pegasus Exchange;
    </p>
    <p class="p1">
      5.Ketika Konsumen merekam dam mengunggah suatu konten yang bersifat user
      generated di platform Pegasus Exchange;
    </p>
    <p class="p1">
      6.Ketika Konsumen menggunakan fungsi chatting di platform Pegasus
      Exchange;
    </p>
    <p class="p1">7.Pencegahan perbuatan melawan hukum;</p>
    <p class="p1">
      8.Kepatuhan terhadap peraturan perundang-undangan dan atau kegunaan lain
      yang diizinkan oleh Konsumen;
    </p>
    <p class="p1">
      9.Ketika Konsumen berinteraksi dengan kami secara offline, termasuk ketika
      Konsumen berinteraksi dengan Karyawan Pegasus Exchange secara offline yang
      kami alih dayakan.
    </p>
    <p class="p1">
      10.Dengan tunduk pada ketentuan di atas, Pegasus Exchange dapat
      bekerjasama dan melakukan pertukaran Data Pribadi Konsumen untuk keperluan
      mitigasi risiko dengan Regulator terkait, Partner dan atau Channel Partner
      Pegasus Exchange, serta penyelenggara layanan pendukung berbasis teknologi
      informasi lainnya.
    </p>
    <h2 class="text_h">
      Tujuan Penggunaan Data Pribadi atau Informasi Pribadi
    </h2>
    <p class="p1">
      Pegasus Exchange dapat mengumpulkan dan menggunakan Data Pribadi atau
      Informasi Pribadi Pengguna untuk tujuan sebagai berikut:
    </p>
    <p class="p1">
      1.Untuk memproses pembayaran. Kami dapat menggunakan informasi yang
      Pengguna berikan tentang diri mereka sendiri saat melakukan pemesanan
      hanya untuk memberikan layanan sesuai pesanan tersebut. Kami tidak
      membagikan informasi ini dengan pihak luar kecuali sejauh yang diperlukan
      untuk menyediakan layanan ini.
    </p>
    <p class="p1">
      2.Untuk menjalankan promosi, kontes, survei atau fitur lainnya pada situs
      ini.
    </p>
    <p class="p1">
      3.Untuk mengirim informasi kepada Pengguna, mereka setuju untuk menerima
      tentang topik yang menurut kami menarik bagi mereka.
    </p>
    <p class="p1">4.Untuk mengirimkan email berkala kepada Pengguna;</p>
    <p class="p1">
      5.Kami mungkin menggunakan alamat email untuk mengirim informasi dan
      pembaruan Pengguna yang berkaitan dengan pesanan mereka. Ini juga dapat
      digunakan untuk menanggapi permintaan keterangan, pertanyaan, dan/atau
      permintaan lainnya. Jika Pengguna memutuskan untuk ikut serta ke milis
      kami, mereka akan menerima email yang mungkin berisi berita perusahaan,
      pembaruan, informasi produk atau layanan terkait, dll. Jika sewaktu-waktu
      Pengguna ingin berhenti berlangganan menerima email di kemudian hari, kami
      menyertakan rincian instruksi berhenti berlangganan di bagian bawah setiap
      email.
    </p>
    <p class="p1">
      6.Mencegah dan mendeteksi penipuan, termasuk namun tidak terbatas pada
      penggunaan teknologi deteksi suara untuk menganalisa rekaman percakapan
      telepon Pengguna dengan Pegasus Exchange.
    </p>
    <p class="p1">
      7.Melaksanakan perintah atau kebijakan pemerintah, badan pengaturan atau
      instansi yang berwenang khususnya regulator;
    </p>
    <p class="p1">
      8.Keperluan administratif, atau audit maupun uji tuntas internal Pegasus
      Exchange sehubungan dengan pengembangan kegiatan usaha, ekspansi usaha
      atau peroleh investasi dari investor;
    </p>
    <p class="p1">
      9.Melakukan cross-selling atas produk yang tersedia pada platform Pegasus
      Exchange bagi Pengguna sesuai profil Pengguna;
    </p>
    <p class="p1">
      10.mengidentifikasi Pengguna ketika Anda menghubungi kami atau mengunjungi
      Platform.
    </p>
    <p class="p1">
      11.OJK, pengadilan, kejaksaan, kepolisian, institusi pemerintah lainnya
      baik atas inisiatif Pegasus Exchange atau sebagaimana diwajibkan oleh
      ketentuan hukum dan peraturan perundang-undangan, arahan, instruksi atau
      kebijakan institusi pemerintah atau pejabat pemerintah.
    </p>
    <h2 class="text_h">Pengungkapan Data Pribadi</h2>
    <p class="p1">
      Pegasus Exchange berkomitmen tidak ada penjualan, pembocoran, pengalihan,
      pengalihwujudan, distribusi atau meminjamkan data pribadi Konsumen kepada
      pihak lain, tanpa seizin dari Konsumen, namun tidak bertanggung jawab atas
      kerugian dalam wujud apapun atau resiko kerugian yang Konsumen alami
      maupun pihak manapun akibat atau terkait dengan Data Pribadi tersebut
      meliputi kegagalan atas perlindungan kerahasiaan Data Pribadi, penyerahan,
      akses, perolehan, pengolahan, penyimpanan atau penggunaannya maupun
      pengalihannya, termasuk sengketa, investigasi, audit, penegakan hukum dan
      proses penyelidikan apapun, yang tidak terbukti disebabkan atau melibatkan
      Pegasus Exchange maupun karyawan, perwakilan, kuasa, afiliasi atau pihak
      terkait Pegasus Exchange lainnya, kecuali ketika dalam hal-hal atau
      kejadian berikut:
    </p>
    <p class="p1">
      1.Ketika adanya kebutuhan dari pengungkapan data Konsumen kepada pihak
      lain yang membantu Pegasus Exchange dalam menyediakan layanan pada
      platform Pegasus Exchange dan memproses segala bentuk aktivitas Konsumen
      dalam platform Pegasus Exchange, termasuk namun tidak terbatas pada proses
      transaksi, verifikasi pembayaran, dan lain-lain;
    </p>
    <p class="p1">
      2.Pegasus Exchange dapat memberikan dan menyediakan data atau informasi
      yang relevan kepada mitra usaha atau partner Pegasus Exchange dengan
      sesuai kaidah persetujuan Konsumen untuk menggunakan layanan mitra usaha,
      yang termasuk pada aplikasi, situs atau platform lain yang saling
      mengintegrasikan API atau layanannya, atau mitra usaha yang mana Pegasus
      Exchange telah bekerjasama untuk mengantarkan bentuk layanan promosi,
      kontes atau hal-hal lain yang dikhususkan;
    </p>
    <p class="p1">
      3.Hal-hal lain yang dibutuhkan oleh Pegasus Exchange seperti layanan
      perbankan, pembayaran, dan lain-lain dengan Konsumen dalam hal ini
      termasuk pada penyelesaian kendala maupun hal-hal lainya;
    </p>
    <p class="p1">
      4.Pegasus Exchange dapat menyediakan informasi relevan kepada vendor,
      konsultan, mitra pemasaran, firma riset atau penyedia layanan sejenis;
    </p>
    <p class="p1">
      5.Pegasus Exchange dapat membagikan informasi Konsumen kepada anak
      perusahaan dan afiliasinya untuk membantu memaksimalkan atau memberikan
      pelayanan serta pengolahan data untuk dan atas nama Pegasus Exchange
    </p>
    <p class="p1">
      6.Pegasus Exchange mengungkapkan data Konsumen untuk upaya dalam mematuhi
      dan memenuhi kewajiban hukum dan/atau adanya permintaan yang sah dari
      Lembaga dan Aparat Penegak Hukum Sejenis.
    </p>
    <p class="p1">7.Diminta oleh regulator.</p>
    <p class="p1">
      8.Terdapat dugaan adanya tindak pidana termasuk namun tidak terbatas pada
      tindak pidana penipuan, terorisme atau pencucian uang, untuk keperluan
      investigasi atau penyelidikan, inspeksi maupun penyidikan oleh apparat
      kepolisian, Komisi Pemberantasan Korupsi atau aparat atau institusi
      pemerintah yang berwenang lainnya.
    </p>
    <p class="p1">
      9.Diperlukan untuk tujuan internal audit oleh auditor eksternal Pegasus
      Exchange maupun uji tuntas secara hukum atau finansial oleh konsultan
      hukum atau keuangan independen yang telah terikat oleh perjanjian
      kerahasiaan untuk menjaga kerahasiaan dokumen atau informasi yang berada
      dalam penguasaan Pegasus Exchange, termasuk Data Pribadi; dan/atau
    </p>
    <p class="p1">10.Telah mendapatkan persetujuan dari Pengguna.</p>
    <p class="p1">Informasi Identifikasi Non-Pribadi</p>
    <p class="p1">
      Kami dapat mengumpulkan informasi identifikasi non-pribadi tentang
      Pengguna kapan pun mereka berinteraksi dengan Platform kami. Informasi
      identifikasi non-pribadi mungkin termasuk nama browser, jenis komputer dan
      informasi teknis tentang Pengguna yang berarti terhubung ke Platform kami,
      seperti sistem operasi dan penyedia layanan Internet yang digunakan dan
      informasi serupa lainnya.
    </p>
    <p class="p1">
      Untuk memberikan layanan Push Notification kepada anda, produk kami
      terintegrasi dengan pihak ketiga sebagai Pengembang Perangkat Lunak (PPL),
      yang akan mengumpulkan informasi perangkat dan informasi jaringan Anda.
    </p>
    <p class="p1">
      Cookie Web Browser Situs kami dapat menggunakan "cookies" untuk
      meningkatkan pengalaman pengguna. Browser web pengguna menempatkan cookie
      pada hard drive mereka untuk tujuan pencatatan dan terkadang untuk melacak
      informasi tentangnya. Pengguna dapat memilih untuk menyetel browser web
      mereka untuk menolak cookie, atau untuk memberi tahu Anda saat cookie
      dikirim. Jika mereka melakukannya, perhatikan bahwa beberapa bagian Situs
      mungkin tidak berfungsi dengan baik.
    </p>
    <p class="p1">
      Informasi perangkat meliputi: pengenal perangkat (IMEI, IDFA, ID Android,
      MAC, dan OAID), informasi aplikasi (informasi kerusakan aplikasi, status
      pemberitahuan perubahan, dan daftar perangkat lunak), dan parameter
      perangkat &amp; informasi sistem (jenis perangkat, model perangkat,
      pengoperasian informasi terkait sistem dan perangkat keras).
    </p>
    <p class="p1">
      Informasi jaringan meliputi: alamat IP, informasi WiFi, dan informasi
      stasiun sinyal.
    </p>
    <p class="p1">
      Untuk keamanan informasi Anda, kami telah bekerja dengan pihak ketiga ini
      telah membuat perjanjian keamanan dan kerahasiaan data, serta secara ketat
      akan mematuhi persyaratan privasi dan keamanan data kami. Kecuali kami
      memiliki persetujuan Anda, kami tidak akan membagikan Data Pribadi atau
      Informasi Pribadi Anda kepada mereka.
    </p>
    <p class="p1">Penyimpanan dan Penghapusan Informasi Konsumen</p>
    <p class="p1">
      Konsumen dengan ini setuju bahwa sehubungan dengan penggunaan Layanan
      Pegasus Exchange, maka Kami berhak mengumpulkan informasi tentang Konsumen
      dari waktu ke waktu, yakni:
    </p>
    <p class="p1">
      1.Data Pribadi atau Informasi Pribadi Konsumen hanya akan disimpan selama
      diperlukan untuk memenuhi tujuan dari pengumpulannya, atau selama
      penyimpanan tersebut diperlukan atau diperbolehkan oleh peraturan
      perundang-undangan yang berlaku. Pegasus Exchange akan berhenti menyimpan
      Informasi Pribadi Konsumen, atau menghapus maksud dari dikaitkannya
      Informasi Pribadi Konsumen tersebut dengan anda sebagai individu, segera
      setelah dianggap bahwa tujuan pengumpulan Informasi Pribadi Konsumen
      tersebut tidak lagi dibutuhkan dengan menyimpan Informasi Pribadi dan
      penyimpanan tidak lagi diperlukan untuk tujuan bisnis atau secara hukum.
    </p>
    <p class="p1">
      2.Data Pribadi atau Informasi Pribadi dari Konsumen yang dikumpulkan oleh
      Pegasus Exchange disimpan dapat disimpan, ditransfer, atau diolah oleh
      penyedia layanan pihak ketiga. Pegasus Exchange akan melakukan upaya yang
      wajar untuk memastikan bahwa semua penyedia layanan pihak ketiga tersebut
      memberikan tingkat perlindungan yang sebanding dengan komitmen Pegasus
      Exchange berdasarkan Kebijakan Privasi ini.
    </p>
    <p class="p1">
      3.Data Pribadi atau Informasi Pribadi dari Konsumen juga dapat disimpan
      atau diproses di luar negara Konsumen oleh pihak yang bekerja untuk
      Pegasus Exchange di negara lain, atau oleh penyedia layanan pihak ketiga,
      vendor, pemasok, mitra, kontraktor, atau afiliasi dari Pegasus Exchange.
      Dalam hal tersebut, Pegasus Exchange akan memastikan bahwa Informasi
      Pribadi Konsumen tersebut tetap menjadi subjek dari tingkat perlindungan
      yang sebanding dengan apa yang disyaratkan dalam hukum negara (dan, dalam
      hal apapun, sejalan dengan komitmen kami dalam Kebijakan Privasi ini).
    </p>
    <p class="p1">
      4.Konsumen menyetujui bahwa Pegasus Exchange akan menyimpan Informasi
      Pribadi yang disampaikan atau diberikan oleh Konsumen kepada Pegasus
      Exchange selama paling singkat 5 (lima) tahun sesuai ketentuan 15 ayat (3)
      Peraturan Menteri Komunikasi dan Informatika Nomor 20 Tahun 2016 tentang
      Perlindungan Data Pribadi Dalam Sistem Elektronik dengan tetap
      mengutamakan perlindungan data pribadi Pengguna Layanan.
    </p>
    <p class="p1">
      5.Konsumen menyetujui bahwa Pegasus Exchange akan menyimpan Informasi
      Pribadi yang disampaikan atau diberikan oleh Konsumen kepada Pegasus
      Exchange selama paling singkat 5 (lima) tahun sesuai ketentuan 15 ayat (3)
      Peraturan Menteri Komunikasi dan Informatika Nomor 20 Tahun 2016 tentang
      Perlindungan Data Pribadi Dalam Sistem Elektronik dengan tetap
      mengutamakan perlindungan data pribadi Pengguna Layanan.
    </p>
    <p class="p1">Perlindungan Data Pribadi atau Informasi Pribadi Pengguna</p>
    <p class="p1">
      Setiap Data Pribadi atau Informasi Pribadi yang disampaikan kepada Pegasus
      Exchange sesuai dengan ketentuan Kebijakan Privasi ini akan dilindungi
      dengan upaya sebaik mungkin oleh perangkat keamanan teruji, yang digunakan
      oleh Pegasus Exchange secara elektronik. Meskipun demikian, Kami tidak
      menjamin kerahasiaan informasi yang Konsumen sampaikan tersebut, dalam
      keadaan dimana terdapat pihak-pihak lain yang mengambil atau mempergunakan
      dengan melawan hukum serta tanpa izin Pegasus Exchange. Kami akan berupaya
      sebaik mungkin untuk membatasi akses ke dalam Data Pribadi Konsumen oleh
      pihak yang tidak berwenang, oleh karena itu Pegasus Exchange melakukan
      langkah-langkah:
    </p>
    <p class="p1">
      1.Pengamanan dan berusaha untuk memastikan Data Pribadi Konsumen di sistem
      Pegasus Exchange. Data pribadi Konsumen berada di belakang jaringan yang
      aman dan hanya dapat diakses oleh sejumlah kecil karyawan yang memiliki
      hak akses khusus ke sistem tersebut. Namun demikian, tidak adanya jaminan
      atau keamanan absolut tidak dapat terhindarkan.
    </p>
    <p class="p1">
      2.Menyimpan data pribadi sesuai dengan Undang-Undang Privasi dan/atau
      hukum lain yang berlaku. Yaitu, Pegasus Exchange akan memusnahkan atau
      menganonimkan data pribadi Konsumen ketika Pegasus Exchange secara wajar
      menganggap bahwa:
    </p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> tujuan data pribadi yang dikumpulkan
        itu tidak lagi difungsikan oleh penyimpanan data pribadi tersebut;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> penyimpanan tidak lagi diperlukan untuk
        tujuan hukum atau bisnis apa pun; dan
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> tidak ada surat perintah yang
        melegitimasi untuk melakukan penarikan data pribadi tersebut lebih jauh.
        Jika Konsumen berhenti menggunakan Platform Pegasus Exchange, atau izin
        Konsumen untuk menggunakan Platform dan/atau Layanan diakhiri atau
        ditarik kembali, Pegasus Exchange dapat terus menyimpan, menggunakan
        dan/atau mengungkapkan data pribadi Konsumen sesuai dengan Kebijakan
        Privasi dan kewajiban Pegasus Exchange berdasarkan UU Privasi. Tunduk
        terhadap hukum yang berlaku, Pegasus Exchange dapat secara aman membuang
        data pribadi Konsumen tanpa pemberitahuan sebelumnya kepada Konsumen.
      </li>
    </ul>
    <p class="p1">Penyangkalan Keamanan dan Situs Pihak Ketiga</p>
    <p class="p1">
      1.Pegasus Exchange tidak menjamin keamanan data pribadi dan/atau informasi
      lainnya yang Konsumen berikan pada situs pihak ketiga. Pegasus Exchange
      memang mengimplementasikan variasi tindakan keamanan untuk menjaga
      keselamatan data pribadi Konsumen yang ada atau di bawah kendali Pegasus
      Exchange. Data pribadi Konsumen ditampung di balik jaringan aman dan hanya
      dapat diakses oleh sejumlah orang terbatas yang memiliki hak akses khusus
      ke sistem tersebut, dan diwajibkan untuk menjaga kerahasiaan data pribadi
      tersebut. Apabila Konsumen melakukan pemesanan atau mengakses data
      pribadi, Pegasus Exchange menawarkan Penggunaan server yang aman. Semua
      data pribadi atau informasi sensitif yang Konsumen berikan, dienkripsi ke
      dalam database kami dan hanya bisa diakses sebagaimana yang tertera di
      atas. Data yang dikumpulkan oleh mitra merek-bersama Pegasus Exchange atau
      situs web pihak ketiga (bahkan, jika ditawarkan pada, atau melalui
      Platform Pegasus Exchange) mungkin tidak diterima oleh Pegasus Exchange.
      Oleh karena itu, Pegasus Exchange tidak bertanggung jawab maupun
      mempertanggungjawabkan konten, pengaturan keamanan (atau tidak adanya
      pengaturan keamanan), dan aktivitas situs-situs terkait ini. Situs-situs
      yang terkait ini hanya untuk kenyamanan Konsumen, dan oleh karenanya
      Konsumen mengaksesnya atas risiko Konsumen sendiri. Namun begitu, Pegasus
      Exchange berupaya melindungi integritas Platform Pegasus Exchange dan
      tautan yang ditempatkan pada masing-masing situs, dan oleh karena itu,
      Pegasus Exchange menyambut setiap umpan-balik mengenai situs-situs yang
      tertaut ini (termasuk, tetapi tidak terbatas, jika tautan tertentu tidak
      berfungsi).Pegasus Exchange tidak akan memberi ganti rugi, meresponi dan
      tidak dapat dilibatkan, berikut karyawan, anak perusahaan, afiliasi atau
      perwakilannya, atas setiap klaim, tuntutan, permintaan atau pernyataan
      apapun yang timbul dari atau terkait Kerugian dan Masalah Hukum yang
      diajukan Pengguna tanpa menyertakan perhitungan terperinci, elaboratif,
      spesifik dan pasti yang telah dikuantifisir, akurat dan dapat
      dipertanggungjawabkan atas kerugian riil dan langsung (factual and direct
      damage) yang Pengguna alami, berikut bukti yang dapat diterima di oleh
      pengadilan atau institusi yudisial terkait mengenai kesalahan atau
      kelalaian Pegasus Exchange berdasarkan Pasal 1865 dan 1866 Kitab
      Undang-Undang Hukum Perdata, Pasal 164 Het Herziene Indonesisch Reglement
      dan Pasal 5 ayat 1 Undang-Undang Nomor 11 Tahun 2008 tentang sebagaimana
      diubah dengan Undang - Undang Nomor 19 Tahun 2016 tentang Informasi dan
      Transaksi Elektronik;
    </p>
    <p class="p1">
      2.Pegasus Exchange tidak bertanggung jawab atas akurasi (kecuali Data
      Pribadi yang telah terverifikasi oleh Pengguna sesuai kebijakannya),
      keabsahan, legalitas dan kelengkapan Data Pribadi Pengguna dan tidak
      diwajibkan untuk memberitahu Pengguna atau pihak manapun perihal tersebut
      kecuali diwajibkan secara hukum; dan
    </p>
    <p class="p1">
      3.Pegasus Exchange tidak bertanggung jawab atas pelanggaran hukum Pengguna
      atau hak pihak ketiga manapun akibat atau terkait perolehan atau pemberian
      Data Pribadi. Dalam hal terdapat penunjukan pihak ketiga untuk penyimpanan
      Data Pribadi, maka Pengguna tidak dapat menuntut, meminta ganti rugi atau
      manfaat apapun dari Pegasus Exchange maupun karyawan, kuasa, perwakilan,
      afiliasi atau pihak terkait Pegasus Exchange dalam hal terjadi pelanggaran
      kerahasiaan atau kegagalan perlindungan rahasia Data Pribadi atau Kerugian
      dan Masalah Hukum yang melibatkan, disebabkan atau dilakukan pihak ketiga
      penyimpan Data Pribadi yang bersangkutan. Namun demikian, Pegasus Exchange
      tetap akan berupaya sewajarnya untuk memberitahu Pengguna perihal
      pelanggaran kerahasiaan tersebut ketika Pegasus Exchange mengetahuinya
      dari pihak ketiga tersebut.
    </p>
    <p class="p1">Perubahan Kebijakan Privasi</p>
    <p class="p1">
      1.Pegasus Exchange dapat memperbaharui Kebijakan Privasi ini setiap waktu.
      Dengan ini, Pegasus Exchange menyarankan kepada Konsumen untuk sering
      memeriksa halaman ini agar setiap perubahan tetap mendapat informasi
      tentang bagaimana kami membantu melindungi informasi pribadi yang kami
      kumpulkan. Konsumen mengetahui dan setuju bahwa Konsumen bertanggung jawab
      untuk meninjau kembali kebijakan privasi ini secara berkala dan menyadari
      adanya modifikasi.
    </p>
    <p class="p1">Hak Menolak Penggunaan Data Pribadi untuk Tujuan Pemasaran</p>
    <p class="p1">
      Konsumen memiliki hak untuk meminta Pegasus Exchange agar tidak mengolah
      Data Pribadi Konsumen untuk tujuan pemasaran. Pegasus Exchange akan
      memberitahu Konsumen dan meminta persetujuan dari Konsumen sebelum kami
      menggunakan Data Pribadi Konsumen untuk tujuan tersebut atau jika kami
      bermaksud mengungkapkan Data Pribadi Konsumen kepada pihak ketiga manapun
      untuk tujuan tersebut. Konsumen dapat menggunakan hak-nya untuk menolak
      pengolahan tersebut dengan cara menghubungi team Customer Service Pegasus
      Exchange. Bahkan setelah Anda memberikan persetujuan Anda atas Data
      Pribadi yang akan digunakan untuk tujuan pemasaran, Anda dapat, setiap
      saat setelah itu, menarik persetujuan.
    </p>
    <p class="p1">Konsumen dibawah Umur</p>
    <p class="p1">
      Pegasus Exchange tidak dapat membedakan usia orang yang mengakses dan
      menggunakan website-nya. Jika seorang anak di bawah umur (menurut hukum
      yang berlaku) telah memberikan Data Pribadinya kepada Pegasus Exchange
      tanpa persetujuan orang tua atau walinya, orang tua atau walinya itu harus
      menghubungi Pegasus Exchange untuk menghapus Data Pribadi yang terkait dan
      menghapus nama anak di bawah umur tersebut dari daftar pelanggannya.
    </p>
    <p class="p1">Persetujuan Konsumen atas Kebijakan Privasi</p>
    <p class="p1">
      Kebijakan Privasi ini berlaku untuk semua Konsumen yang mengakses Situs
      Pegasus Exchange. Dengan mengakses dan/atau menggunakan layanan-layanan
      yang tersedia atau melalui situs Pegasus Exchange, maka Konsumen dengan
      ini mengakui dan telah membaca serta menerima dan menyetujui
      ketentuan-ketentuan Kebijakan Privasi ini (beserta dengan
      Ketentuan-Ketentuan Penggunaan). Jika Konsumen tidak menyetujui kebijakan
      ini, mohon jangan gunakan Situs kami. Penggunaan terus-menerus atas Situs
      Pegasus Exchange setelah pengumuman perubahan kebijakan ini akan dianggap
      sebagai penerimaan Konsumen terhadap perubahan tersebut.
    </p>
    <p class="p1">Informasi Keluhan</p>
    <p class="p1">
      Kebijakan Privasi ini dirancang untuk membantu Konsumen mengerti bagaimana
      kami mengumpulkan, menggunakan, mengungkapkan dan/atau mengolah Data
      Pribadi yang Konsumen telah berikan kepada kami, serta membantu Konsumen
      dalam mengambil keputusan yang diberitahukan sebelum memberikan Data
      Pribadi Konsumen kepada kami, sehingga apabila Konsumen memiliki
      pertanyaan dan keluhan mengenai kebijakan privasi platform Pegasus
      Exchange mohon hubungi melalui email di
      <a href="mailto:corporateservice@pegasusexchange.id"
        >corporateservice@pegasusexchange.id</a
      >
    </p>
    <p class="p1 updated"><em>Pembaharuan Terakhir : 20/05/2026</em></p>
  </div>
</template>
<script>
// node_modules

// applibs

export default {
  components: {},
  data() {
    return {
      web_domain: "pegasusexchange.id",
    };
  },
};
</script>
<style scoped>
.text_h {
  margin-left: -20px;
  padding-top: 20px;
}
h2.head_txt {
  margin-top: 14pt;
  margin-bottom: 14pt;
  text-align: justify;
  font-size: 18pt;
}
.subtitle {
  font-weight: 600;
  margin-bottom: 1rem;
}
.updated {
  margin-top: 2rem;
  font-style: italic;
}
.p1 {
  margin-top: 14pt;
  margin-bottom: 14pt;
  text-align: justify;
  font-size: 16px;
}
.ul-letter,
.ul-sub {
  margin: 0 0 14pt 0;
  padding-left: 32pt;
  list-style: none;
}
.li-letter,
.li-sub {
  margin-top: 10pt;
  text-align: justify;
  font-size: 16px;
}
.li-label {
  font-weight: 600;
}
.text_h,
h1,
h2 {
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
}
.ctr_trm {
  max-width: 932px;
  padding: 0 20px;
  z-index: 995;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.head_txt {
  font-size: 28px;
  margin-left: -20px;
}
.ctr_trm a {
  color: #4da3ff;
  word-break: break-all;
}
@media (max-width: 500px) {
  .text_h,
  .head_txt,
  h1,
  h2 {
    font-size: 16px;
    margin-top: 20px;
  }
  .p1,
  .li-letter,
  .li-sub {
    font-size: 14px;
  }
}
</style>
